import * as React from "react";
import { NoProductsIllustration } from "vega-illustrations";

type Props = {
  description?: string;
};

export const EmptyFundsList = ({ description }: Props) => (
  <div className="flex min-h-80 w-full flex-col items-center justify-center gap-4 px-6 py-12">
    <NoProductsIllustration />
    {description != null ? (
      <p className="body-base-regular max-w-sm text-center text-text/secondary">
        {description}
      </p>
    ) : null}
  </div>
);
